import styles from './pictures.module.scss';
import { useCourseGetRequestHook } from 'libs/webkua-lib/src/lib/requestUtils';
import { ValueFormatterParams } from 'ag-grid-community';
import { CreateHeaders, ErrorButton, HeaderSizeEnum, Icon, MOBILE_BREAK_POINT, SecondaryButton, iconHeader, textHeader, useWindowSizeHook } from '@frontend-workspace/react-shared-lib';
import RightsWrapper from 'libs/webkua-lib/src/lib/rights-wrapper/rights-wrapper';
import { VisuallyHiddenInput } from '../../helpers';
import { useState } from 'react';
import DeletePictureDialog from './delete-picture-dialog/delete-picture-dialog';
import WebkuaTable from '../../../webkua-table/webkua-table';
import PicturesSkeleton from './pictures-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface PicturesProps { }

export function Pictures(props: PicturesProps) {
  const { data: images, isLoading, getData: getImages }: { data: string[], isLoading: boolean, getData: () => void } = useCourseGetRequestHook("images", []);

  const { t } = useTranslation();
  const [viewWidth, viewHeight] = useWindowSizeHook();
  const [deleteImage, setDeleteImage] = useState<undefined>(undefined);

  const openDeleteImageDialog = (e: any) => setDeleteImage(e.data);
  const closeDeleteImageDialog = () => setDeleteImage(undefined);

  const deleteRenderer = (params: ValueFormatterParams) => {
    return (
      <ErrorButton
        variant="outlined"
        size='small'
        onClick={() => openDeleteImageDialog(params)}>
        {t('standard.delete')}
      </ErrorButton>
    );
  }

  const imageData = images.map(url => {
    const parts = url.split('/');
    let lastPartUrl = parts[parts.length - 1];
    // lastPartUrl = lastPartUrl.replace(/\.(png|PNG)$/, '');
    return {
      iconUrl: url,
      name: lastPartUrl
    };
  });

  return (<>
    {/* <RightsWrapper>
      <div className='mb-3'>
        <SecondaryButton
          component="label"
          variant="contained"
          startIcon={<Icon>cloud_upload</Icon>}
          disabled>
          {t('picture.uploadNewImage')}
          <VisuallyHiddenInput type="file" />
        </SecondaryButton>
      </div>
    </RightsWrapper> */}
    {isLoading ? <PicturesSkeleton /> :
      <WebkuaTable
        data={imageData}
        headers={CreateHeaders([
          ...viewWidth > MOBILE_BREAK_POINT ? [iconHeader("", "")] : [],
          textHeader("name", t('standard.name'), HeaderSizeEnum.MEDIUM),
          textHeader("", "", HeaderSizeEnum.MEDIUM, {
            renderer: deleteRenderer,
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          })
        ])}
      />}
    {deleteImage && <DeletePictureDialog
      onClose={closeDeleteImageDialog}
      open={!!deleteImage}
      refreshData={getImages}
      deleteImage={deleteImage}
    />}
  </>);
}

export default Pictures;
